import { Wrench, Bell, ClipboardList, Package, Inbox, CheckCircle2, BellRing, CalendarClock, BarChart3 } from 'lucide-react';

// Katalog der Home-Screen-Aktionen (reine Konfiguration). Das home_layout des Profils
// bestimmt, welche Keys in welcher Reihenfolge erscheinen; `right` (falls gesetzt) macht die
// Sichtbarkeit von den Funktionsrechten des Nutzers abhaengig. Beschriftungen stehen NICHT hier
// — sie liegen in den i18n-Bundles unter `pm.action.<key>.label` / `.sub`, mit demselben
// Aktions-Key, damit sie mit der Sprache uebersetzen.
// Das Meister-Dashboard ist KEINE Kachel mehr — es lebt als einklappbare Sektion direkt auf
// dem Home (HomeScreen -> DashboardPanel, gated auf canApprove).
export const ACTION_CATALOG = {
  'create-order':        { icon: Wrench, right: 'canCreateOrder', built: true },
  'create-notification': { icon: Bell, right: 'canCreateNotification', built: true },
  'my-orders':           { icon: ClipboardList, right: null, built: true },
  'material-search':     { icon: Package, right: null, built: true },
  'backlog':             { icon: Inbox, right: null, built: true },
  'approvals':           { icon: CheckCircle2, right: 'canApprove', built: true },
  'notifications':       { icon: BellRing, right: null, built: true },
  'preventive':          { icon: CalendarClock, right: 'canManagePreventive', built: true },
  'reports':             { icon: BarChart3, right: null, built: true },
};
